import React from 'react'

export default function CandidateTable ({ candidates }) {
  return (
    <table className="table--candidates">
      <thead>
        <tr>
          <td>Nombre</td>
          <td>Email</td>
          <td>Celular</td>
          <td>Alternativo</td>
          <td>Lugar de residencia</td>
          <td>Zip Code</td>
          <td>Licencia Ocupacional</td>
          <td>Atributo</td>
          <td>Cambio de locación</td>
          <td>Relocacion fuera de PR</td>
          <td>Intereses</td>
          <td>Experiencia en</td>
          <td>Habilidades</td>
          <td>Centro educativo</td>
          <td>CV</td>
        </tr>
      </thead>
      <tbody>
        {candidates.map(candidate => {
          return (
            <tr key={candidate.id}>
              <td>{candidate.name}</td>
              <td>{candidate.email}</td>
              <td>{candidate.cellphone}</td>
              <td>{candidate.alternative_phone}</td>
              <td>{candidate.residence}</td>
              <td>{candidate.zip_code}</td>
              <td>{candidate.occupational_license}</td>
              <td>{candidate.defining_attribute}</td>
              <td>{candidate.can_move ? 'Si' : 'No'}</td>
              <td>{candidate.can_relocate ? 'Si' : 'No'}</td>
              <td>{candidate.interests}</td>
              <td>{candidate.experienced}</td>
              <td>{candidate.skills}</td>
              <td>{candidate.education_center}</td>
              <td>
                {candidate.cv ? <a href={candidate.cv} target="_blank">Descargar</a> : null}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
